import React from 'react'
import {Nav, Navbar, NavbarBrand, NavItem, NavbarToggler, Collapse} from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.css';
import './navigator.css';
import {get_version, x2xxPlats, x3xxPlats, x4xxPlats, trunc} from "../../utes/appUtils";
import * as deviceConstants from '../../devices';

class Navigator extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.loadConfigCallback = this.props.loadConfig;
        this.state = {
            modal: false,
            dropdownOpen:false,
            isOpen: false,
            loadConfigFile: null,
            loadConfigFileName:''

        };
        this.getDefaultFileName = this.getDefaultFileName.bind(this);
        this.handleGenFiles = this.handleGenFiles.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.loadConfig = this.loadConfig.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleDropdownOpen = this.toggleDropdownOpen.bind(this);

    }

    loadConfig() {
        this.loadConfigCallback(this.state.loadConfigFile);
    }
    /**
     * update the config file when changed by the user.
     * @param e
     */
    handleFileChange(e){
        /* check if a file as actually selected... */
        let conf = e.target.files[0];
        if (conf) {
            if (window.confirm("This will overwrite the current configuration. Are you sure you want to continue?")) {
                let configFileName = trunc(e.target.files[0].name);
                this.setState({
                    loadConfigFile: conf,
                    loadConfigFileName: configFileName
                });
                this.loadConfigCallback(conf);
            }

        }
        else {
            let configFileName = '';
            this.setState({loadConfigFile: null,
                loadConfigFileName: configFileName});
        }

    }

    getDefaultFileName() {
        // remove "AT" (and anything after dash for ATM33)
        if (x2xxPlats.includes(get_version(this.props.selectedBoard))) {
            return 'pinmap_' + this.props.selectedBoard.slice(2).split('-')[0].toLowerCase() + "_overlay";
        } else { // ATM3x
            let board_number = this.props.selectedBoard.slice(3).split('-')
            let suffix;
            if (x3xxPlats.includes(get_version(this.props.selectedBoard))) { // ATM33
                suffix = board_number[1].slice(-2).toUpperCase();
            } else { // ATM34
                suffix = board_number[1].replace(/x/g, "").toUpperCase() + "_" + x4xxPlats[0].split('-').slice(-1);
            }
            return 'pinmap_ATMEVK_' + board_number[0].toLowerCase() + "_" + suffix + "_overlay";
        }
    }

    handleGenFiles(){
        this.props.generateFiles(this.getDefaultFileName());
    }

    toggleModal() {
        this.setState(prevState => ({
          modal: !prevState.modal
        }));
    }
    toggleDropdownOpen() {
        this.setState(prevState => ({
          dropdownOpen: !prevState.dropdownOpen
        }));
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        let atmx2xx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return x2xxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        let atmx3xx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return x3xxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        let atmx4xx = Object.keys(deviceConstants.boardPinMap).filter((val) => {
            return x4xxPlats.includes(get_version(val))
        }).map((val) => {
            return (
                <option value={val}>{val}</option>
            );
        });

        return (
            <Navbar className="pinmux-nav" color="light" light expand="md">
                <NavbarBrand className="nav-atmosic-logo">
                    <img src="./atmosic_logo.png" alt="Atmosic Technologies"/>
                </NavbarBrand>
                <NavbarToggler onClick={this.toggle} />
                <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav navbar>
                        <NavItem>
                            <form onSubmit={this.handleSubmit}>
                                <label className="nav-link board-selector">
                                <span>
                                Product:
                                </span>
                                    <select className="selected-board" value={this.props.selectedBoard} onChange={this.props.boardCallback}>
                                        <optgroup label="ATMx2xx">
                                            {atmx2xx}
                                        </optgroup>
                                        <optgroup label="ATM33xx">
                                            {atmx3xx}
                                        </optgroup>
                                        <optgroup label="ATM34xx">
                                            {atmx4xx}
                                        </optgroup>
                                    </select>
                                </label>
                            </form>
                        </NavItem>
                        <NavItem>
                            <span className="nav-link">
                                |
                            </span>
                        </NavItem>
                        <NavItem>
                            <span className="nav-link" onClick={this.props.generateConfig}>
                                Save Config
                            </span>
                        </NavItem>
                         <NavItem>
                            <span className="nav-link">
                                |
                            </span>
                        </NavItem>
                        <NavItem>
                            <label htmlFor="fileInput">
                                <input className="inputfile"  type="file" name="fileInput" id="fileInput" accept="application/json, .json" onChange={this.handleFileChange}/>
                                <div className="config-file-wrapper">
                                    <span className="nav-link config-file" >
                                        {(this.state.loadConfigFile === null) ? 'Load Config' : this.state.loadConfigFileName}
                                    </span>
                                </div>
                            </label>
                        </NavItem>
                    </Nav>
                    <Nav className="ml-auto" style={{float: 'right'}} navbar>
                        <NavItem>
                            <span className="nav-link gen-button-wrapper">
                            <Button className="genButton" color="light" onClick={this.handleGenFiles} >Generate Files</Button>
                            </span>
                        </NavItem>
                        <NavItem>
                            <span className="nav-link">
                                <a href={process.env.PUBLIC_URL + '/help_page/index.html'} rel="noopener noreferrer" target="_blank">Help</a>
                            </span>
                        </NavItem>
                    </Nav>
                </Collapse>
                        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={this.props.className}>
          <ModalHeader toggle={this.toggleModal}>About PinMux Tool</ModalHeader>
          <ModalBody>
              <p style={{textAlign: 'center'}}>
                  Atmosic PinMux Tool<br></br>
                  <br></br>
                  Release: 0.0<br></br>
                  Requirements: Chrome 7+, Firefox 4+, Opera 11+, Safari 12+<br></br>
                  Copyright: 2019 Atmosic<br></br>
              </p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleModal}>Close</Button>
          </ModalFooter>
        </Modal>

            </Navbar>
        );
    }
}

export default Navigator;
